export default "__VITE_ASSET__a56a204d__"